import { render, staticRenderFns } from "./CustomWheelEditor.vue?vue&type=template&id=3b9393d5&scoped=true&"
import script from "./CustomWheelEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomWheelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CustomWheelEditor.vue?vue&type=style&index=0&id=3b9393d5&lang=scss&scoped=true&"
import style1 from "./CustomWheelEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9393d5",
  null
  
)

export default component.exports